import { all, call } from "redux-saga/effects";

import watchCasinoTournamentInstancesRequest from "./casinoTournamentInstances";
import watchGameBoxRaffleRequest from "./gameBoxRaffle";
import watchGameBoxRaffleTicketRequest from "./gameBoxRaffleTickets";
import watchGameBoxRaffleUpdateRequest from "./gameBoxRaffleUpdate";
import watchGameBoxMissionRequest from "./gameBoxMission";
import watchGameBoxNextInstanceTemplateRequest from "./gameBoxNextInstanceTemplate";
import watchMissionRequest from "./mission";
import { watchRequestFreespinsWageringGames } from "./getFreespinsWageringGames";
import watchRequestGameUrl from "./getGameUrl";
import watchProgressiveMissionsRequest from "./progressiveMissions";
import watchRacesRequest from "./races";
import watchRacesLeaderboardRequest from "./racesLeaderboard";
import watchJoinToRaceRequest from "./joinToRace";
import watchOptMissionRequest from "./opt";
import watchMiniGamesRequest from "./miniGames";
import watchJoinTOSportRequest from "./joinToSport";

function* rootSaga() {
  yield all([
    call(watchGameBoxMissionRequest),
    call(watchMissionRequest),
    call(watchGameBoxRaffleRequest),
    call(watchGameBoxRaffleTicketRequest),
    call(watchGameBoxRaffleUpdateRequest),
    call(watchGameBoxNextInstanceTemplateRequest),
    call(watchRequestFreespinsWageringGames),
    call(watchRequestGameUrl),
    call(watchCasinoTournamentInstancesRequest),
    call(watchProgressiveMissionsRequest),
    call(watchRacesRequest),
    call(watchMiniGamesRequest),
    call(watchRacesLeaderboardRequest),
    call(watchJoinToRaceRequest),
    call(watchOptMissionRequest),
    call(watchJoinTOSportRequest),
  ]);
}

export default rootSaga;
